import React, { Component } from "react";
import Img from "gatsby-image";
import { Link } from "gatsby";
import moment from "moment";



export default class Blog extends Component {
  render() {

    const { blogs } = this.props;
    console.log("blogs:", blogs)
    return (
      <article
        id="blog"
        className={`${this.props.article === 'blog' ? 'active' : ''} ${this.props.articleTimeout ? 'timeout' : ''
          }`}
        style={{ display: 'none' }}
      >
        <h2 className="major">Blog</h2>
        <ul className="blogs">
          {blogs.map((item, index) => {
            return (
              <li className="blog__item" key={index}>
                <Link to={`/${item.node.slug}`}>
                  {item.node.featureImage ? (
                    <Img
                      fluid={item.node.featureImage.fluid}
                      objectFit="cover"
                      objectPosition="50% 50%"
                    />
                  ) : (
                    <div className="blog__item__no-image"></div>
                  )}
                  <div className="blog__item__details">
                    <span className="blog__item__date">
                      {moment(item.node.createdAt).format("LL")}
                    </span>
                    <h3 className="blog__item__title">{item.node.title}</h3>
                  </div>
                </Link>
              </li>
            )
          })}
        </ul>
        {this.props.close}
      </article>
    );
  }
}
